import { handleResponse, handleError, getBaseUrl } from "./apiUtils";
const baseUrl = getBaseUrl();

export async function uploadImage(formData) {
  const requestUrl = `${baseUrl}/images/uploadimage`;

  return await fetch(requestUrl, {
    method: "POST",
    body: formData,
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function getImage(imageId) {
  return await fetch(`${baseUrl}/images/getimage/${imageId}`)
    .then(handleResponse)
    .catch(handleError);
}

export async function getEntityHasImages(entityId) {
  return await fetch(`${baseUrl}/images/getEntityHasImages/${entityId}`)
    .then(handleResponse)
    .catch(handleError);
}

export async function deleteImage(imageId) {
  return await fetch(`${baseUrl}/images/deleteImage/${imageId}`, {
    method: "DELETE",
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function deleteImageForEntity(entityId, imageId) {
  return await fetch(`${baseUrl}/images/deleteImageForEntity/${entityId}/${imageId}`, {
    method: "DELETE"
  })
  .then(handleResponse)
  .catch(handleError);
}

export async function uploadImageForEntity(entityId, formData) {
  const requestUrl = `${baseUrl}/images/uploadimageforentity/${entityId}`;

  return await fetch(requestUrl, {
    method: "POST",
    body: formData,
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function getImagesForEntity(entityId, ownerKey) {
  let getImagesURL = `${baseUrl}/images/getimagesforentity/${entityId}`;

  if (ownerKey && ownerKey !== "") {
    getImagesURL = getImagesURL.concat(`?ownedByKey=${ownerKey}`);
  }
  return await fetch(getImagesURL).then(handleResponse).catch(handleError);
}

export async function getImagesForEntityCount(entityId, ownerKey) {
  let getImagesURL = `${baseUrl}/images/getimagesforentitycount/${entityId}`;

  if (ownerKey && ownerKey !== "") {
    getImagesURL = getImagesURL.concat(`?ownedByKey=${ownerKey}`);
  }
  return await fetch(getImagesURL).then(handleResponse).catch(handleError);
}
